<template>
  <div class="container">
    <vs-button
      @click="confirm"
      color="primary"
      icon-pack="feather"
      :icon="loading ? null : 'icon-check'"
      class="w-full max-w-xs m-auto"
      :size="size"
      :class="className"
    >
      <div v-if="loading">
        <loader color="#ffffff" size="7px" />
        <progress-bar
          v-if="hasProgress"
          :progress="progress"
          @cancel="cancel"
        />
      </div>
      <span v-else>{{ title }}</span>
    </vs-button>

    <!-- <vs-button
      v-if="loading"
      @click="cancel"
      color="danger"
      size="small"
      icon-pack="feather"
      icon="icon-x"
      class="cancel"
    /> -->
  </div>
</template>

<script>
import Loader from "../Loader.vue";
import ProgressBar from "../progress-bar/ProgressBar.vue";

export default {
  components: { Loader, ProgressBar },
  props: {
    title: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
    },
    progress: {
      type: Number,
      required: false,
    },
    hasProgress: {
      type: Boolean,
      required: false,
      default: true,
    },
    size: {
      type: String,
      required: false,
    },
    className: {
      type: String,
      required: false,
    },
  },
  methods: {
    confirm() {
      if (this.loading) return;

      this.$emit("confirm");
    },
    cancel() {
      this.$emit("cancelUpload");
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  flex: 1;
  display: flex;
  position: relative;
  max-width: 22rem;

  @media (max-width: 480px) {
    max-width: 16rem;
  }

  .cancel {
    position: absolute;
    border-radius: 50%;
    left: -20px;
    top: calc((100% - 28px) / 2);
  }
}
</style>